<div class="flex justify-content-center pt-6">
  <div class="md:col-8 sm:col-12 lg:col-6 xl:col-6 p-1 md:p-0">
    <p-card class="">
      <ng-template pTemplate="content">
        <div class="text-center">
          <i class="fas fa-check-circle mb-3 green-icon"></i>
          <h1 class="green-text text-3xl">¡Presupuesto generado!</h1>
          <h1 class="green-text text-3xl">{{ numero }}</h1>
          <p class="md:px-8 px-3 mb-0">
            Revisa tu presupuesto haciendo clic en el botón de abajo o
            accediendo al módulo 'Presupuestos' dentro de tu perfil cuando lo
            desees
          </p>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <div class="flex gap-1">
          <p-button
            class="w-4 p-0"
            size="small"
            routerLink="/carro-compra/downloadpdf"
            [queryParams]="{ numero: numero }"
          >
            <div class="flex flex-column">
              <i class="pi pi-file-pdf"></i>
              <span class="px-1">Descargar presupuesto</span>
            </div>
          </p-button>
          <p-button
            class="w-4 p-0"
            size="small"
            routerLink="/mi-cuenta/presupuestos"
          >
            <div class="flex flex-column">
              <i class="pi pi-file"></i>
              <span class="px-1">Ver mis presupuestos</span>
            </div>
          </p-button>
          <p-button
            class="w-4 p-0"
            size="small"
            [routerLink]="['/', 'inicio']"
          >
            <div class="flex flex-column">
              <i class="pi pi-home"></i>
              <span class="px-1">Ir al home</span>
            </div>
          </p-button>
        </div>
      </ng-template>
    </p-card>
  </div>
</div>
